import { symbolAppId, symbolMenuI18nNamespace, symbolOverrideApp } from "./constants.js";
import { hasOwnProperty, isObject } from "@next-core/utils/general";
import { pipes } from "@next-core/pipes";
import { isEvaluable } from "@next-core/cook";
export function computeMenuData(data, overrideAppId, runtimeContext, helpers) {
  if ("titleDataSource" in data && isObject(data.titleDataSource) && Object.entries(data.titleDataSource).every(_ref => {
    let [, value] = _ref;
    return value === null || value === "";
  })) {
    delete data.titleDataSource;
  }
  if ("if" in data && data.if === null) {
    delete data.if;
  }
  if ("to" in data && data.to && !isEvaluable(data.to)) {
    const yaml = pipes.yaml(data.to);
    if (isObject(yaml) && ["pathname", "search", "hash"].some(key => hasOwnProperty(yaml, key))) {
      data.to = yaml;
    }
  }
  let newRuntimeContext = runtimeContext;
  if (overrideAppId !== runtimeContext.app.id) {
    var _helpers$getStoryboar;
    const overrideApp = window.STANDALONE_MICRO_APPS ? data[symbolOverrideApp] : (_helpers$getStoryboar = helpers.getStoryboardByAppId(overrideAppId)) === null || _helpers$getStoryboar === void 0 ? void 0 : _helpers$getStoryboar.app;
    newRuntimeContext = {
      ...runtimeContext,
      overrideApp,
      appendI18nNamespace: data[symbolMenuI18nNamespace]
    };
  }
  return helpers.asyncComputeRealValue(data, newRuntimeContext, {
    ignoreSymbols: true
  });
}
export function computeMenuItems(items, runtimeContext, helpers) {
  return Promise.all(items.map(async _ref2 => {
    let {
      children,
      ...rest
    } = _ref2;
    const [computedRest, computedChildren] = await Promise.all([computeMenuData(rest, rest[symbolAppId], runtimeContext, helpers), children && (await computeMenuItems(children, runtimeContext, helpers))]);
    return {
      ...computedRest,
      children: computedChildren
    };
  }));
}
//# sourceMappingURL=computeMenuData.js.map